import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../Shared/Services/api.service';
import { PlanService } from '../../Plans/Services/plan.service';
import { REVENUE_SCAN_PAGE_SIZE } from '../../../Consts/backoffice.const';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { PlanSubscriberListResponse } from '../../../Interfaces/api/backoffice/plan.interface';
import { PlanRevenue } from '../../../Models/backoffice/plan-revenue.model';
import { PlanSummary } from '../../../Models/backoffice/plan-summary.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly _apiService = inject(ApiService);
  private readonly _planService = inject(PlanService);

  planRevenue(plan: PlanSummary): Observable<PlanRevenue> {
    const request = this._planService.subscribersRequest(plan.id, 0, REVENUE_SCAN_PAGE_SIZE);

    return this._apiService
      .run<LaravelDefaultResponse<PlanSubscriberListResponse>>(request)
      .pipe(map((response) => this._toPlanRevenue(plan, response)));
  }

  private _toPlanRevenue(
    plan: PlanSummary,
    response: LaravelDefaultResponse<PlanSubscriberListResponse>,
  ): PlanRevenue {
    const rows = response.data?.subscribers ?? [];
    const total = response.data?.total ?? rows.length;
    const revenue = rows.reduce((sum, row) => sum + Number(row.mrr ?? 0), 0);

    return new PlanRevenue(plan, rows.length, Math.round(revenue * 100) / 100, total);
  }
}
